<template>
  <router-view></router-view>
</template>

<script>
export default {
  name:  'exhibition-activity-allactivity',
  data() {
    return {

    }
  },
  created() {
    document.title = "中国国际医疗器械博览会 - 活动计划";
  }
}
</script>

<style scoped lang="scss">

</style>
